import { createRoot } from "react-dom/client";
import { App } from "./App";
import { BrowserRouter } from "react-router";
import { Configuration } from "Context/Configuration";
import "./Styles/global.scss";
import { ApplicationInsights, DistributedTracingModes } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { UrlHelper } from "aphrodite.react/Helpers";

const browserHistory = createBrowserHistory();

Configuration.refresh()
    .then(() => {
        const configuration = Configuration.get();

        if (configuration.appInsightsUri) {
            const reactPlugin = new ReactPlugin();
            const appInsights = new ApplicationInsights({
                config: {
                    correlationHeaderDomains: [UrlHelper.host(configuration.apiUri!), UrlHelper.host(window.location.toString())],
                    connectionString: configuration.appInsightsUri,
                    distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
                    enableAutoRouteTracking: true,
                    enableRequestHeaderTracking: true,
                    enableResponseHeaderTracking: true,
                    enableCorsCorrelation: true,
                    excludeRequestFromAutoTrackingPatterns: ["stream-io-api.com"],
                    extensions: [reactPlugin],
                    extensionConfig: {
                        [reactPlugin.identifier]: { history: browserHistory }
                    }
                }
            });

            appInsights.loadAppInsights();
        }

        const container = document.getElementById("root")!;
        const root = createRoot(container);
        root.render(
            <BrowserRouter>
                <App />
            </BrowserRouter>
        );
    });